module.exports = __webpack_public_path__ + "assets/img/32_577.a255ab21.jpg";